import { cloneDeep, merge, assign, get } from 'lodash';

import ActionTypes from "../../redux/actionTypes/actionTypes";

export default function (state = {}, action) {
    const { modalKey, inputMap, callback } = action;
    const modalState = get(state, [modalKey]);

    switch (action.type) {
        case ActionTypes.SHOW_MODAL:
            state = merge(cloneDeep(state), { [modalKey]: { show: true, callback } });
            break;
        case ActionTypes.HIDE_MODAL:
            state = merge(cloneDeep(state), { [modalKey]: { show: false } });
            break;
        case ActionTypes.UPDATE_INPUTS_MODAL:
            const updatedModalState = assign({}, modalState, { inputMap });
            state = assign({}, state, { [modalKey]: updatedModalState });
            break;
        default:
            break;
    }

    return state;
}